import Vue from 'vue'

/** После обновления Vuex seoPage — пересобрать head из metaInfo (vue-meta). */
export function refreshVueMeta(router) {
  const app = router && router.app
  if (!app || typeof app.$meta !== 'function') {
    return
  }
  return Vue.nextTick().then(() => {
    app.$meta().refresh()
  })
}
